/**
 * 인증 방식
 */
export enum AuthProvider {
  NONE = 'none',
  EMAIL = 'email',
  GOOGLE = 'google',
  KAKAO = 'kakao',
}

/**
 * 이용자 유형 (대표, 구성원)
 */
export enum UserType {
  OWNER = 'owner',
  MEMBER = 'member',
}

/**
 * 파일 업로드 요청 데이터 타입
 */
export enum FileUploadType {
  BUSINESS_LICENSE = 'business_license',
  BANK_STATEMENT = 'bank_statement',
  BUSINESS_CARD = 'business_card',
}

/**
 * 중복 체크 대상 타입
 */
export enum AvailabilityCheckType {
  USER = 'USER_ID',
  COMPANY = 'BUSINESS_NUMBER',
}
